import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import CombineDataPng2x from './assets/CombineData@2x.png'
import CombineDataWebp from './assets/CombineData.webp'
import CombineDataWebp2x from './assets/CombineData@2x.webp'
import CombineDataWebp3x from './assets/CombineData@3x.webp'

const copy = {
  heading: `Combine data across sources`,
  description: `Sync advertising and revenue data from Google AdWords, Facebook Ads, Stripe, and more into your data
warehouse to accurately measure campaign performance.`,
}

const link = {
  text: `View Segment Sources`,
  url: `/docs/connections/sources/catalog/`,
}

const CombineData = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="2Col">
      <SectionCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <picture>
          <source type="image/webp" srcSet={`${CombineDataWebp}, ${CombineDataWebp2x} 2x, ${CombineDataWebp3x} 3x`} />
          <StyledImage
            src={CombineDataPng2x}
            alt="Illustration: Activate anywhere"
            width="961"
            height="871"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledImage = styled(Image)`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default CombineData
